module.exports = __webpack_public_path__ + "static/media/DSC_0112-bz.105d9ff2.jpg";